import React from "react";
import { convertHTMLEntity } from "../../libs/utils";
// import { FormattedMessage } from "react-intl";

const UserInfo = props => {
  const {
    user
  } = props;
  return (
    <div className="fiftyCol">
      <div>
        <div className="azureFont">{user.profile.firstName} {user.profile.lastName}</div>
      </div>
      <div>
        {/* <div className="h3Font"><FormattedMessage id="generic.email" /></div>*/}
        <div className="azureFontMail">
          {/** le mail troppo lunghe vanno troncate uso il trucco &#8203; per farle andare a capo senza rompere parole */
            convertHTMLEntity((user?.profile?.authId ? user.profile.authId : user?.profile?.id)
              .replace("@", "@&#8203;")
              .replace(".", "&#8203;."))}
        </div>
      </div>
      {/* <div style={{marginBottom: "40px"}}>
        <a href={TSID_PUBLIC_URL}
          id="goToTSDigital"
          aria-label={"Link al portale Agyo per la modifica della password"}
          tabIndex="0">
          <Button kind="secondary">
            <FormattedMessage id="profile.modifyPassword"/>
          </Button>
        </a>
  </div>*/}
    </div>);

};

export default UserInfo;